export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-1.png?9b8ba7c08a2ea4a3dc77049a637c6d4a";